import { Injectable } from '@angular/core';
import { SubjectEnum } from '../utils/notes.utils';
import { extractNotes } from '../utils/pricelist.functions';
import { PriceListNote } from '../models/priceslist-note.model';

@Injectable({
  providedIn: 'root',
})
export class NotesService {
  getNotes(notes: PriceListNote[] | undefined, subjectToFilterBy: typeof SubjectEnum | string) {
    const filteredNotes = notes?.filter((note) => note?.subject === subjectToFilterBy);
    if (filteredNotes) {
      return extractNotes(filteredNotes);
    }
    return undefined;
  }
}
